import * as utilsUsuarios from '@/libs/usuarios';

/**
 * Decorator para el json de usuario
 */
export default class Usuario {
  constructor(data, _options = {}) {
    Object.assign(this, data);
  }

  get nombreCompleto() {
    return utilsUsuarios.fullname(this);
  }

  get displayGrupoPrincipal() {
    return this.grupo_academico_principal?.etiqueta;
  }
}
